// Canned demo data — used by the public Preview page so visitors can poke around
// without touching the backend. All IDs are stable so URLs deep-link cleanly.

export const DEMO_USER = {
  user_id: "demo-user",
  name: "Sarah Chen",
  email: "sarah@demo.co",
  picture: null,
  subscription_status: "trial",
};

export const DEMO_EMPLOYEES = [
  { employee_id: "demo-emp-1", name: "Alice Johnson",  email: "alice@demo.co",   skills: ["barista", "lead"], max_hours_per_week: 38, min_hours_per_week: 30 },
  { employee_id: "demo-emp-2", name: "Bob Patel",      email: "bob@demo.co",     skills: ["barista"],          max_hours_per_week: 40, min_hours_per_week: 20 },
  { employee_id: "demo-emp-3", name: "Carla Singh",    email: "carla@demo.co",   skills: ["barista", "lead"], max_hours_per_week: 38, min_hours_per_week: 30 },
  { employee_id: "demo-emp-4", name: "Dan Liu",        email: "dan@demo.co",     skills: ["floor"],            max_hours_per_week: 20, min_hours_per_week: 12 },
  { employee_id: "demo-emp-5", name: "Erin McCarthy",  email: "erin@demo.co",    skills: ["floor", "lead"],   max_hours_per_week: 38, min_hours_per_week: 30 },
];

export const DEMO_SHIFTS = [
  { shift_id: "demo-shift-1", name: "Open",  start_time: "06:00", end_time: "14:00", color: "#A78BFA", min_staff: 2, max_staff: 3, frequency: "everyday" },
  { shift_id: "demo-shift-2", name: "Mid",   start_time: "10:00", end_time: "18:00", color: "#F59E0B", min_staff: 1, max_staff: 2, frequency: "weekdays" },
  { shift_id: "demo-shift-3", name: "Close", start_time: "14:00", end_time: "22:00", color: "#3B82F6", min_staff: 2, max_staff: 3, frequency: "everyday" },
];

export const DEMO_RULES = [
  { rule_id: "demo-r-1", name: "Max 40 hrs / week",     rule_type: "max_hours_per_week",        value: 40, is_hard: true,  enabled: true },
  { rule_id: "demo-r-2", name: "Min 10 hrs rest",       rule_type: "min_rest_between_shifts",   value: 10, is_hard: true,  enabled: true },
  { rule_id: "demo-r-3", name: "Max 5 consec days",     rule_type: "max_consecutive_days",      value: 5,  is_hard: true,  enabled: true },
  { rule_id: "demo-r-4", name: "Fair weekends",         rule_type: "fair_weekend_distribution", value: 1,  is_hard: false, enabled: true },
];

export const DEMO_OPERATIONS = [
  { operation_id: "demo-op-1", name: "Team training", dates: ["2026-06-04"], shift_id: "demo-shift-2", staff_required: 3, is_hard: true,  color: "#A78BFA", notes: "Mandatory product update training." },
];

const DEMO_START = "2026-06-01";
const DEMO_END = "2026-06-14";

// Pre-computed roster — 14 days, 5 employees, balanced
export const DEMO_ROSTER = {
  roster_id: "demo-roster-1",
  user_id: "demo-user",
  name: "Demo Roster — first two weeks of June",
  start_date: DEMO_START,
  end_date: DEMO_END,
  status: "published",
  entries: (() => {
    const entries = [];
    const days = [];
    const fmtLocal = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
    const start = new Date(`${DEMO_START}T00:00:00`);
    for (let i = 0; i < 14; i++) {
      const d = new Date(start); d.setDate(start.getDate() + i);
      days.push(fmtLocal(d));
    }
    const pattern = [
      // [open, mid (weekdays), close]
      ["demo-emp-1", "demo-emp-2"],
      ["demo-emp-3"],
      ["demo-emp-4", "demo-emp-5"],
    ];
    days.forEach((dateStr, di) => {
      const dow = new Date(`${dateStr}T00:00:00`).getDay();
      const isWeekend = dow === 0 || dow === 6;
      pattern.forEach((emps, si) => {
        if (si === 1 && isWeekend) return; // Mid is weekdays only
        const shift_id = DEMO_SHIFTS[si].shift_id;
        // Rotate assignment slightly day-to-day
        emps.forEach((eid, slot) => {
          const rotated = pattern[si][(slot + di) % emps.length];
          entries.push({
            entry_id: `demo-e-${di}-${si}-${slot}`,
            date: dateStr,
            employee_id: rotated,
            shift_id,
            notes: "",
            is_locked: false,
          });
        });
      });
    });
    return entries;
  })(),
};

export const DEMO_TIME_OFF = [
  // Carla has approved annual leave on June 9-10
  {
    request_id: "demo-to-1",
    employee_id: "demo-emp-3",
    start_date: "2026-06-09",
    end_date: "2026-06-10",
    leave_type: "annual",
    status: "approved",
    reason: "Family wedding",
  },
];

export const DEMO_HEALTH = {
  overall: 92,
  errors: 0,
  warnings: 2,
  categories: [
    { name: "Coverage",       score: 100, detail: "All slots filled" },
    { name: "Rest",           score: 96,  detail: "All ≥10 hrs" },
    { name: "Hours fairness", score: 88,  detail: "Within 4 hrs of even split" },
    { name: "Weekends",       score: 90,  detail: "Distributed within 1 weekend" },
    { name: "Skills",         score: 86,  detail: "1 close shift missing lead" },
  ],
};
